import * as React from 'react';
import Modal from '../../../../core/components/Modal/Modal';
// @ts-ignore
import styles from '../CaseDetailsTiles.module.scss';
import { PaymentProviderType } from '../../../types/PaymentProviderType';
import { PaymentProviderListVM } from '../../../types/PaymentProviderListVM';
import ApiProvider from '../../../../core/api/ApiProvider';
import Status from '../../../../core/types/Status';
import { InfoMessageService, TranslationService } from '../../../../core/services';
import { Loader, ModuleContainer } from '../../../../core/components';
import { useParams } from 'react-router-dom';

type Props = {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onPay: (providerId: PaymentProviderType) => void;
};

const ProvidersModal = (props: Props) => {
  const { caseNumber, tenantUId } = useParams() as { caseNumber: string; tenantUId: string };
  const { isOpen, onToggle, onPay } = props;
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [model, setModel] = React.useState<PaymentProviderListVM>({} as PaymentProviderListVM);

  const getAvailablePaymentProviders = async (): Promise<Status<PaymentProviderListVM>> => {
    return await ApiProvider.get<Status<PaymentProviderListVM>>(
      `CaseDetailsTilesModule/GetAvailablePaymentProviders`
    );
  };

  const fetchData = async () => {
    try {
      const data = await getAvailablePaymentProviders();
      if (!data.success) {
        InfoMessageService.error(data.message);
        onToggle(false);
      } else {
        if (data.data.paymentProviders.length === 1) {
          onPay(data.data.paymentProviders[0].type);
          onToggle(false);
        } else {
          setModel(data.data);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchData();
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onToggle={onToggle}
        className={styles.modalWrapper}
        closeBtnClass="modal-close-btn"
      >
        <ModuleContainer classNames="mt-0 mb-0" variant={ModuleContainer.ModuleVariant.Variant1}>
          <ModuleContainer.Header title={TranslationService.translate('ChooseProvider')} />
          {isLoading && <Loader opacity={0.4} />}
          <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
            <div className={styles.grid}>
              {model.paymentProviders &&
                model.paymentProviders.map((provider) => {
                  return (
                    <button
                      key={provider.type}
                      onClick={() => {
                        setIsLoading(true);
                        onPay(provider.type);
                      }}
                      id={`PayWith_${PaymentProviderType[provider.type]}`}
                      className={styles.providersTile}
                      disabled={isLoading}
                      data-cy={provider.type}
                    >
                      <img
                        src={provider.logo}
                        className={styles.providersLogo}
                        alt="Logo"
                        data-cy={`PaymentProviderEnum-${provider.type}`}
                      />
                    </button>
                  );
                })}
            </div>
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>
    </>
  );
};

export default ProvidersModal;
